export default __webpack_public_path__ + "static/11_16-d8eb7b729e5229a2828dc4d64d6565f8.png";